export class StorageStatusDto {
    available: boolean;
    storageType: string;
    checkedAt: number;
    message: string;

    constructor(src: Partial<StorageStatusDto>) {
        this.available = !!src.available;
        this.storageType = src.storageType || '';
        this.checkedAt = src.checkedAt || 0;
        this.message = src.message || '';
    }
}
